import { render, staticRenderFns } from "./domicile.vue?vue&type=template&id=47d2f078&scoped=true&"
import script from "./domicile.vue?vue&type=script&lang=js&"
export * from "./domicile.vue?vue&type=script&lang=js&"
import style0 from "./domicile.vue?vue&type=style&index=0&id=47d2f078&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d2f078",
  null
  
)

export default component.exports